import { z } from "zod";

export enum EntityType {
  Asset = "asset",
  Block = "block",
  Idea = "note",
  Task = "task",
}

export const FavoriteSchema = z.object({
  id: z.string().uuid(),
  organizationId: z.string().uuid(),
  creatorId: z.string(),
  entityType: z.union([z.nativeEnum(EntityType), z.string()]),
  entityId: z.string(),
  createdAt: z.date(),
});

export const FilterFavoriteParamsSchema = z.object({
  entityType: FavoriteSchema.shape.entityType,
  entityIds: z.array(FavoriteSchema.shape.entityId).optional(),
});

export const CreateFavoriteSchema = z.object({
  entityType: FavoriteSchema.shape.entityType,
  entityId: FavoriteSchema.shape.entityId,
});

export type Favorite = z.infer<typeof FavoriteSchema>;
export type FilterFavoriteParams = z.infer<typeof FilterFavoriteParamsSchema>;
export type CreateFavorite = z.infer<typeof CreateFavoriteSchema>;
